"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useTrackReconnectIntegration = exports.useTrackBrokenIntegration = exports.useIntegrationPayload = void 0;

var _react = require("react");

var _services = require("@alycecom/services");

var _useGiftContext2 = require("./useGiftContext");

var useIntegrationPayload = function useIntegrationPayload() {
  var provider = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  var _useGiftContext = (0, _useGiftContext2.useGiftContext)(),
      id = _useGiftContext.user.id;

  return (0, _react.useMemo)(function () {
    return {
      user_id: id,
      provider
    };
  }, [id, provider]);
};

exports.useIntegrationPayload = useIntegrationPayload;

var useTrackBrokenIntegration = function useTrackBrokenIntegration() {
  var provider = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var payload = useIntegrationPayload(provider);

  var _TrackEvent$useTrackE = _services.TrackEvent.useTrackEvent(),
      trackEvent = _TrackEvent$useTrackE.trackEvent;

  (0, _react.useEffect)(function () {
    trackEvent('Email disconnected notification — viewed', payload);
  }, [payload, trackEvent]);
};

exports.useTrackBrokenIntegration = useTrackBrokenIntegration;

var useTrackReconnectIntegration = function useTrackReconnectIntegration() {
  var provider = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var payload = useIntegrationPayload(provider);

  var _TrackEvent$useTrackE2 = _services.TrackEvent.useTrackEvent(),
      trackEvent = _TrackEvent$useTrackE2.trackEvent;

  return (0, _react.useCallback)(function () {
    trackEvent('Email reconnect link — clicked', payload);
  }, [payload, trackEvent]);
};

exports.useTrackReconnectIntegration = useTrackReconnectIntegration;